export const Messages = {
  deliveryInfoParams: {
    param1: 'メール通知設定',
    paramNoDetail: '納品確定情報',
    memo: 'メモ',
  },
  NotiSetting: {
    param1: '得意先通知設定',
  },
  AddressSetting: {
    param1: '商流拠点コード',
    param2: 'メールアドレス通知設定',
    param3: 'メールアドレス',
  },
  M0001_I: '{param1}が未入力です。',
  M0002_I: '有効なメールアドレスではありません。',
  M0003_I: '{param1}が既に存在します。',
  M0004_C: '{param1}を削除しますか。',
  M0005_I: '{param1}を正しく入力してください。',
  M0006_I: '{param1}は存在していません。正しく入力したことをご確認ください。',
  M0007_I: '結果件数が0件です。',
  M0008_C: '{param1}変更してもよろしいでしょうか。',
  M0009_I: '{param1}の変更が完了しました。',
  M0010_E: '{param1}の変更が失敗しました。',
  M0011_I: '{param1}が存在していません。',
  M0012_W: '変更内容を保存しますか？',
  M0013_I: '有効なメールアドレスではありません。',
  M0014_I: '{param1}の削除が完了しました。',
  M0015_E: '{param1}の削除が失敗しました。',
  M0016_W:
    '編集していたレコードは、編集セッション中に他のユーザーによって更新されました。\nレコードを再読み込みしてから、再更新してください。',
  M0017_I: '{param1}：{param2}処理を開始しました。',
  M0018_E: '{0}出力ファイルへの書き込みに失敗しました。',
  M0019_I: '{param1}：{param2}処理は正常に終了しました。',
  M0020_I: 'OUTPUT {param1} {param2} 件',
  M0021_I: '{param1}：{param2}処理は正常に終了しました。',
  M0022_E: '接続されていません。',
  M0023_E: 'エラーが発生しました。 詳細については、管理者にお問い合わせください。',
  placeHolderEmail: 'メールアドレス',
  buttonAction: {
    ok: 'OK',
    cancel: 'キャンセル',
  },
  saveOrNot: {
    save: '保存し、別ページへ',
    notSave: '保存せず、別ページへ',
    cancel: 'キャンセル',
  },
  saveOrNotFromSearch: {
    save: '保存し、検索実行',
    notSave: '保存せず、検索実行',
    cancel: 'キャンセル',
  },
  saveOrNotFromMenu: {
    save: '保存し、別メニューへ',
    notSave: '保存せず、別メニューへ',
    cancel: 'キャンセル',
  },
};
